import { logError } from "@lib/logger";
import { IEventDataSource } from "@/types/interfaces";
import { BigBashEvent } from "@/types/types";
import { CustomEventType } from "@/events/CustomEventRegistry";
import { sharedStyles } from "@lib/sharedStyles";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("event-table-row")
export class EventTableRow extends LitElement {
	static readonly styles = [
		sharedStyles,
		css`

	.event-row {
	  display: flex;
	  align-items: center;
	  padding: 12px;
	  justify-content: space-between;
	gap: 8px;
	}

	.table-cell {
	  flex: 1;
	}

    .event-row:hover {	
      background: #f8f9fa;
    }

    .actions {
      display: flex;
      gap: 8px;
    }
  `];

	@property({ type: Object }) event: BigBashEvent;
	@property({ type: Object }) eventDataSource: IEventDataSource;

	constructor(eventDataSource: IEventDataSource) {
		super();
		this.eventDataSource = eventDataSource;
	}

	private _formatDate(date: Date) {
		return {
			date: date.toLocaleDateString("de-DE", { year: "numeric", month: "long", day: "numeric" }),
			time: date.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })
		};
	}

	private _handleEditClick(e: Event) {
		e.preventDefault();
		window.location.href = `/host/update-event/${this.event.id}`;
	}

	private _handleStartClick(e: Event) {
		e.preventDefault();
		window.location.href = `/host/moderate-event/${this.event.id}`;
	}

	private async _handleDeleteClick(e: Event) {
		e.preventDefault();
		if (!this._confirmDelete()) {
			return;
		}
		await this._tryToDeleteEvent();
	}

	private _confirmDelete() {
		return confirm(`Möchtest du das Event "${this.event.name}" wirklich löschen?`);
	}

	private async _tryToDeleteEvent() {
		try {
			await this.eventDataSource.deleteEvent(this.event.id);
			this.dispatchEvent(new CustomEvent(CustomEventType.DELETE_EVENT, {
				detail: { id: this.event.id },
				bubbles: true,
				composed: true
			}));
			alert(`Event "${this.event.name}" wurde erfolgreich gelöscht.`);
		} catch (error) {
			logError("Fehler beim Löschen des Events:", error);
			alert("Beim Löschen des Events ist ein Fehler aufgetreten.");
		}
	}

	render() {
		const { date, time } = this._formatDate(this.event.datetime);
		return html`
		<div class="event-row">
       		<div class="table-cell">
          			<div class="text-body--small">${date}</div>
          			<div class="text-body--small" style="color: #999;">${time} Uhr</div>
        		</div>
        		<div class="table-cell">
          			<div class="text-body--small">${this.event.name}</div>
        		</div>
				<div class="table-cell">
					<span class="text-body--small">
						${this.event.teams.length} Teams, 
						${this.event.teams.reduce((acc, t) => acc + (t.players?.length ?? 0), 0)} Spieler
					</span>
				</div>
				<div class="table-cell" style="flex: 2;">
					<div class="actions">
						<warning-button @click="${this._handleEditClick}">
							Bearbeiten
						</warning-button>
						<success-button @click="${this._handleStartClick}">
                            Start
                        </success-button>
						<alert-button @click="${this._handleDeleteClick}">
							Löschen
						</alert-button>
					</div>
				</div>
			</div>
    	`;
	}
}

export default EventTableRow;